import React from 'react'
import {formatDatetime} from '../../util/date_util'
import {railsToJsTimezoneMap} from '../../util/timezone_utils'
import UserAvatar from '../photographers/photograher_avatar'
import ShootConfirmationControls from '../shoot_confirmation_controls'

export default function ProjectAppointmentDetails({project, appointments, canManage, isAdmin, onEditAddress, onReschedule, onDecline, onNavigate}) {
  const timezone = project?.address?.timezone || project?.client?.timezone
  const ianaTimezone = railsToJsTimezoneMap[timezone] || timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
  const today = new Date().toLocaleDateString('en-CA', {timeZone: ianaTimezone})
  const canEdit = ({packages}) => isAdmin || (
    new Date(packages[0].appointment_time) > new Date() &&
    new Date(packages[0].appointment_time).toLocaleDateString('en-CA', {timeZone: ianaTimezone}) !== today
  )
  const reschedule = (appointment) => <button type="button" className="projectDetailAction"
    onClick={e => onReschedule(e, appointment.photographer, appointment.packages, appointment.packages[0])}>Reschedule</button>
  const editable = appointments.filter(appointment => canManage && canEdit(appointment))
  const address = project?.address
  const addressText = [address?.apartment_number, address?.formatted_address || [address?.street1, address?.city, address?.region, address?.zip_code].filter(Boolean).join(', ')].filter(Boolean).join(' ')

  return <div className="projectAppointmentDetails">
    <div className="projectAppointmentAddress">
      <span className="projectAppointmentLabel">Property address</span>
      <div className="projectAppointmentAddressLine">
        <button type="button" className="projectAppointmentAddressLink" onClick={() => onNavigate(address)}>{addressText}</button>
        {editable.length > 0 && <button type="button" className="projectDetailAction" onClick={onEditAddress}>Edit Address</button>}
      </div>
    </div>
    <div className="projectAppointmentList">
      {appointments.map((appointment, index) => {
        const {photographer, packages} = appointment
        const showDecline = isAdmin && onDecline && !appointments.slice(0, index).some(item => item.photographer?.id === photographer?.id)
        return <div className="projectAppointmentRow" key={`${photographer?.id}-${packages[0].appointment_time}`}>
          <div className="projectAppointmentPerson">
            <div className="projectPersonAvatar"><UserAvatar user={photographer} /></div>
            <div className="projectPersonText">
            <div className="projectAppointmentIdentity">
              <strong>{photographer?.first_name} {photographer?.last_name?.trim().charAt(0).toUpperCase()}</strong>
              <span>{[...new Set(packages.map(pack => pack.service_title))].join(', ')}</span>
            </div>
            <div className="projectAppointmentDate">{formatDatetime(packages[0].appointment_time, 'MM/DD/YYYY, hh:mm A z', timezone)}</div>
            {isAdmin && (project.shoot_assignments || []).filter(item => item.contractor_id === photographer?.id && new Date(item.appointment_time).getTime() === new Date(packages[0].appointment_time).getTime()).map(item => <ShootConfirmationControls key={item.assignment_key} assignment={item} readOnly/>)}
            </div>
          </div>
          {((canManage && canEdit(appointment)) || showDecline) && <div className="projectAppointmentActions">
            {canManage && canEdit(appointment) && reschedule(appointment)}
            {showDecline && <button type="button" className="projectDetailAction projectAppointmentDecline" onClick={() => onDecline(photographer.id)}>Decline Job</button>}
          </div>}
        </div>
      })}
    </div>
  </div>
}
